/* LIOR recently viewed products.
   Records the current product handle (window.LIOR_RV_HANDLE) in localStorage "lior_rv"
   (newest first, de-duplicated, max 12) and fills any [data-lior-rv] section on the page
   with cards identical to the "You may also like" cards (incl. the "+" quick add, which uses
   the theme's own <product-form> element so the cart drawer behaves like the theme's quick add). */
(function () {
  'use strict';

  if (window.__liorRecentlyViewedLoaded) return;
  window.__liorRecentlyViewedLoaded = true;

  var STORAGE_KEY = 'lior_rv';
  var MAX_STORED = 12;

  function readList() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      var seen = {};
      var out = [];
      for (var i = 0; i < parsed.length; i++) {
        var handle = parsed[i];
        if (typeof handle !== 'string' || !handle || seen[handle]) continue;
        seen[handle] = true;
        out.push(handle);
      }
      return out;
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (error) {
      /* storage unavailable (private mode, quota) - ignore */
    }
  }

  function forget(handle) {
    writeList(readList().filter(function (h) { return h !== handle; }));
  }

  var currentHandle = typeof window.LIOR_RV_HANDLE === 'string' ? window.LIOR_RV_HANDLE : '';

  if (currentHandle) {
    var updated = readList().filter(function (h) { return h !== currentHandle; });
    updated.unshift(currentHandle);
    writeList(updated);
  }

  var sections = document.querySelectorAll('[data-lior-rv]');
  if (!sections.length) return;

  function routesRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof root !== 'string' || !root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function fetchProduct(handle) {
    var url = routesRoot() + 'products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (response.status === 404) {
          forget(handle);
          return null;
        }
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (product) {
        return product && product.handle ? product : null;
      })
      .catch(function () {
        return null;
      });
  }

  function collect(handles, limit) {
    var results = [];
    var index = 0;
    function step() {
      if (results.length >= limit || index >= handles.length) {
        return Promise.resolve(results.slice(0, limit));
      }
      var batch = handles.slice(index, index + (limit - results.length));
      index += batch.length;
      return Promise.all(batch.map(fetchProduct)).then(function (products) {
        for (var i = 0; i < products.length; i++) {
          if (products[i]) results.push(products[i]);
        }
        return step();
      });
    }
    return step();
  }

  function mediaSrc(media) {
    if (!media) return '';
    if (typeof media === 'string') return media;
    if (media.preview_image && media.preview_image.src) return String(media.preview_image.src);
    return String(media.src || media.url || '');
  }

  function mediaRatio(media) {
    if (!media || typeof media !== 'object') return 0;
    var ratio = Number(media.aspect_ratio || (media.preview_image && media.preview_image.aspect_ratio));
    return isNaN(ratio) ? 0 : ratio;
  }

  function sizedUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcset(src) {
    return [360, 533, 720, 940, 1066].map(function (w) { return sizedUrl(src, w) + ' ' + w + 'w'; }).join(', ');
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  /* LIOR 2026-10-02: Recently viewed prices copy the main price's format for the active currency.
     sections/lior-recently-viewed.liquid renders two sample amounts with the same money filter and dollar-prefix
     block as the main price (snippets/price.liquid): data-money-sample = 1234.00, data-money-sample-small = 0.05,
     e.g. "€1.234,00" / "€0,05", "1.234,00 Kč", "A$1,234.00", "¥1,234" / "¥0", "1.234 Ft". The text before and after
     the number, the thousands and decimal separators and the number of decimals are read from the first sample;
     the format is only used when it reproduces both samples exactly, otherwise the old formatting below runs. */
  function sampleMoneyFormat(section) {
    if (section.__liorMoneySample !== undefined) return section.__liorMoneySample;
    section.__liorMoneySample = null;
    var big = section.getAttribute('data-money-sample') || '';
    var small = section.getAttribute('data-money-sample-small') || '';
    var start = big.search(/\d/);
    var end = big.length;
    while (end > 0 && !/\d/.test(big.charAt(end - 1))) end--;
    if (start < 0 || !small) return null;
    var runs = big.slice(start, end).match(/\d+|\D+/g);
    var digits = runs.join('').replace(/\D/g, '');
    var fmt = { prefix: big.slice(0, start), suffix: big.slice(end), thousands: '', decimal: '', precision: 0 };
    if (digits === '123400' && runs.length === 5) {
      fmt.thousands = runs[1];
      fmt.decimal = runs[3];
      fmt.precision = 2;
    } else if (digits === '123400' && runs.length === 3) {
      fmt.decimal = runs[1];
      fmt.precision = 2;
    } else if (digits === '1234' && runs.length === 3) {
      fmt.thousands = runs[1];
    } else if (!(digits === '1234' && runs.length === 1)) {
      return null;
    }
    var check = function (cents) {
      return fmt.prefix + formatWithDelimiters(cents, fmt.precision, fmt.thousands, fmt.decimal) + fmt.suffix;
    };
    if (check(123400) !== big || check(5) !== small) return null;
    section.__liorMoneySample = fmt;
    return fmt;
  }

  /* LIOR 2026-11-04 (owner): ".00 only shows when there is a need for it" - whole amounts drop the zero cents. */
  function formatMoney(cents, section) {
    return String(formatMoneyFull(cents, section)).replace(/([.,])00(?=\D*$)/, '');
  }

  function formatMoneyFull(cents, section) {
    cents = Number(cents);
    if (isNaN(cents)) return '';
    var sample = sampleMoneyFormat(section);
    if (sample) return sample.prefix + formatWithDelimiters(cents, sample.precision, sample.thousands, sample.decimal) + sample.suffix;
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var shopCurrency = section.getAttribute('data-shop-currency') || '';
    var format = (section.getAttribute('data-money-format') || '').replace(/<[^>]*>/g, '');

    var localPrefix = { AUD: 'A$', NZD: 'NZ$', CAD: 'C$', SGD: 'S$', HKD: 'HK$', MXN: 'MX$' }[active];
    if (localPrefix) return localPrefix + formatWithDelimiters(cents, 2, ',', '.');

    if (active && shopCurrency && active !== shopCurrency) format = '';

    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    if (!match) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: active || shopCurrency || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function pickVariant(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  var SIZES = '(min-width: 1400px) 313px, (min-width: 990px) calc((100vw - 148px) / 4), (min-width: 750px) calc((100vw - 132px) / 3), calc((100vw - 48px) / 3)';

  function imgTag(src, className, alt) {
    return '<img src="' + esc(sizedUrl(src, 1066)) + '" srcset="' + esc(srcset(src)) + '" sizes="' + esc(SIZES) +
      '" alt="' + esc(alt) + '" width="1066" height="1066" loading="lazy" class="' + className + '">';
  }

  var PLUS_ICON = '<svg class="lior-pcard__plus" viewBox="0 0 18 18" fill="none" focusable="false" aria-hidden="true">' +
    '<path d="M9 2v14M2 9h14" stroke="currentColor" stroke-width="1.5" vector-effect="non-scaling-stroke"/></svg>';
  var SPINNER = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

  /* Same markup as the cards in sections/lior-you-may-also-like.liquid. The "+" button sits in the
     theme's own <product-form> (defined by the theme's main.js), so adding to cart, the cart drawer
     refresh/open and the cart-update event all run through the theme's code. */
  function cardHtml(product, section) {
    var url = product.url || routesRoot() + 'products/' + encodeURIComponent(product.handle);
    var title = product.title || '';
    var media = Array.isArray(product.media) ? product.media : [];
    var first = mediaSrc(media[0]) || mediaSrc(product.featured_image) || (Array.isArray(product.images) ? mediaSrc(product.images[0]) : '');
    var second = media.length > 1 ? mediaSrc(media[1]) : '';
    var ratio = mediaRatio(media[0]);
    var fit = ratio >= 0.98 && ratio <= 1.02 ? 'fill' : 'contain';

    var variant = pickVariant(product);
    var price = variant ? Number(variant.price) : Number(product.price);
    var compare = variant ? Number(variant.compare_at_price || 0) : Number(product.compare_at_price || 0);
    var onSale = compare > price;

    var sectionId = section.getAttribute('data-section-id') || 'lior-rv';
    var formId = 'quick-add-' + sectionId + product.id;
    var addUrl = section.getAttribute('data-cart-add-url') ||
      (window.routes && window.routes.cart_add_url) || routesRoot() + 'cart/add';
    var soldOut = section.getAttribute('data-sold-out-label') || 'Sold out';

    var html = '<div class="lior-pcard">';
    html += '<div class="lior-pcard__media lior-pcard__media--' + fit + (second ? ' lior-pcard__media--has-secondary' : '') + '">';
    html += '<a class="lior-pcard__media-link" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">';
    if (first) html += imgTag(first, 'lior-pcard__img lior-pcard__img--primary', title);
    if (second) html += imgTag(second, 'lior-pcard__img lior-pcard__img--secondary', '');
    html += '</a>';

    if (onSale) {
      html += '<span class="lior-pcard__badge">Save ' + Math.floor(((compare - price) * 100) / compare) + '%</span>';
    }

    if (variant && variant.available) {
      html += '<product-form id="product-form-' + esc(formId) + '" class="lior-pcard__quick-add">';
      html += '<form method="post" action="' + esc(addUrl) + '" id="' + esc(formId) + '" accept-charset="UTF-8" class="lior-pcard__form"' +
        ' enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">';
      html += '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';
      html += '<div class="hidden product-form__variants" data-values=""></div>';
      html += '<input type="hidden" name="id" value="' + esc(variant.id) + '">';
      if (product.requires_selling_plan && Array.isArray(variant.selling_plan_allocations) && variant.selling_plan_allocations.length) {
        html += '<input type="hidden" name="selling_plan" value="' + esc(variant.selling_plan_allocations[0].selling_plan_id) + '">';
      }
      html += '<button id="' + esc(formId) + '-submit" type="submit" name="add" class="lior-pcard__add"' +
        ' aria-label="' + esc('Add ' + title + ' to cart') + '" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true">';
      html += '<span class="lior-pcard__add-icon" aria-hidden="true">' + PLUS_ICON + '</span>';
      html += '<span class="sold-out-message hidden">' + esc(soldOut) + '</span>';
      html += '<span class="loading-overlay__spinner hidden">' + SPINNER + '</span>';
      html += '</button>';
      html += '<input type="hidden" name="product-id" value="' + esc(product.id) + '">';
      html += '<input type="hidden" name="section-id" value="' + esc(sectionId) + '">';
      html += '</form></product-form>';
    }
    html += '</div>';

    html += '<h3 class="lior-pcard__title"><a href="' + esc(url) + '">' + esc(title) + '</a></h3>';

    html += '<div class="lior-pcard__price">';
    if (onSale) {
      html += '<span class="visually-hidden">Sale price</span>';
      html += '<span class="lior-pcard__price-sale">' + esc(formatMoney(price, section)) + '</span>';
      html += '<span class="visually-hidden">Regular price</span>';
      html += '<s class="lior-pcard__price-compare">' + esc(formatMoney(compare, section)) + '</s>';
    } else {
      html += '<span class="lior-pcard__price-regular">' + esc(formatMoney(price, section)) + '</span>';
    }
    html += '</div>';
    html += '</div>';
    return html;
  }

  function buildCard(product, section) {
    var item = document.createElement('li');
    item.className = 'lior-rail__item';
    item.innerHTML = cardHtml(product, section);
    return item;
  }

  function render(section) {
    if (section.__liorRvRendered) return;
    section.__liorRvRendered = true;

    var grid = section.querySelector('[data-lior-rv-grid]');
    if (!grid) return;

    var limit = parseInt(section.getAttribute('data-limit'), 10);
    if (isNaN(limit) || limit < 1) limit = 4;
    var exclude = section.getAttribute('data-exclude') || currentHandle;

    var handles = readList().filter(function (h) { return h !== exclude; });
    if (!handles.length) return;

    collect(handles, limit).then(function (products) {
      products = products.filter(function (p) { return p.handle !== exclude; });
      if (!products.length) return;
      var fragment = document.createDocumentFragment();
      products.forEach(function (product) {
        fragment.appendChild(buildCard(product, section));
      });
      grid.innerHTML = '';
      grid.appendChild(fragment);
      section.style.display = '';
      section.classList.add('lior-rv--ready');
      var placeholder = section.querySelector('[data-lior-rv-placeholder]');
      if (placeholder) placeholder.remove();
      if (window.LiorCarousel && typeof window.LiorCarousel.refresh === 'function') {
        window.LiorCarousel.refresh(section);
      }
    });
  }

  for (var s = 0; s < sections.length; s++) render(sections[s]);
})();
